import { useEffect, useState } from "react";
import styles from "../postDetailComponent/postDetailComponent.module.scss";
import { useRouter } from "next/router";
import { convertSlugs } from "../../util/functionGlobal";
import { ICategory } from "../../model/base";
import { getAuthorInfo } from "../postDetailComponent/dataAuthor";
import Link from "next/link";

interface InfoAuthorProps {
    breadcrumb: ICategory[];
    cateMapping: any[];
    title: string;
    description?: string;
    url:string;
    modDate: string;
    view?: string;
    img: string;
    createdBy?: string;
}

export function Author(props: InfoAuthorProps) {
    const { breadcrumb, title, description, url, modDate, view, img, createdBy, cateMapping } = props;
    const breadcrumbSortById = breadcrumb
        .filter((item) => cateMapping.some((cate) => cate.category_id === item.id))
        .sort((a, b) => {
            return a.id - b.id;
        }).reverse();
    const cateDepth0 = breadcrumbSortById.find((item) => item.depth === 0);
    const cateDepthNotZero = breadcrumbSortById.find((item) => item.depth > 0);
    //const createdBys = "Vân DK#48";
    const author = getAuthorInfo(createdBy ?? "Vân ĐK");
    if (!author) {
        return true;
    }

    return (
        <>
            <div className={styles["info-author"]}>
                <div className={styles["heading-author"]}>
                    <div className={styles["image"]}>
                        <img src={process.env.NEXT_PUBLIC_BASE_PATH + author.imageAuthor} alt={author.nameAuthor} />
                    </div>
                    <div className={styles["info-title"]}>
                        <span>Tác giả</span>
                        <Link href={author.linkAuthor} title={author.nameAuthor} target="_blank">{author.nameAuthor}</Link>
                        <p>{author.titleAuthor}</p>
                    </div>
                </div>
                <div className={styles["description-info"]}>{author.descriptionAuthor}</div>
                <a
                  href="https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung"
                  title="Quy trình biên tập nội dung tại Sapo" target="_blank"
                >
                  Quy trình biên tập nội dung tại Sapo
                </a>
            </div>
        </>
    );
};

export default Author;
